"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.finalizeAddPaymentDetailsSlice = exports.fetchFinalizeAddPaymentDetails = exports.default = void 0;
var _toolkit = require("@reduxjs/toolkit");
var _api = require("../api");
var _eventDispatcher = _interopRequireWildcard(require("../util/eventDispatcher"));
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
const initialState = {
  loading: false,
  paymentDetails: null,
  error: null
};
const fetchFinalizeAddPaymentDetails = exports.fetchFinalizeAddPaymentDetails = (0, _toolkit.createAsyncThunk)('finalizeAddPaymentDetails', async (_ref, _ref2) => {
  let {
    paymentMethodId,
    details
  } = _ref;
  let {
    getState,
    rejectWithValue
  } = _ref2;
  const {
    paymentMethods: {
      selectedPaymentMethod
    }
  } = getState();
  try {
    const {
      paymentDetails
    } = await (0, _api.finalizeAddPaymentDetails)(paymentMethodId || (selectedPaymentMethod === null || selectedPaymentMethod === void 0 ? void 0 : selectedPaymentMethod.id), details);
    return paymentDetails;
  } catch (err) {
    return rejectWithValue(err.message);
  }
});
const finalizeAddPaymentDetailsSlice = exports.finalizeAddPaymentDetailsSlice = (0, _toolkit.createSlice)({
  name: 'finalizeAddPaymentDetails',
  initialState,
  reducers: {},
  extraReducers: {
    [fetchFinalizeAddPaymentDetails.pending]: state => {
      state.loading = true;
    },
    [fetchFinalizeAddPaymentDetails.fulfilled]: (state, _ref3) => {
      let {
        payload
      } = _ref3;
      state.loading = false;
      state.paymentDetails = payload;
      state.error = null;
      (0, _eventDispatcher.default)(_eventDispatcher.MSSDK_UPDATE_PAYMENT_DETAILS_SUCCESSFUL, {
        payload
      });
    },
    [fetchFinalizeAddPaymentDetails.rejected]: (state, _ref4) => {
      let {
        payload
      } = _ref4;
      state.loading = false;
      state.error = payload;
      (0, _eventDispatcher.default)(_eventDispatcher.MSSDK_UPDATE_PAYMENT_DETAILS_FAILED, {
        payload
      });
    }
  }
});
var _default = exports.default = finalizeAddPaymentDetailsSlice.reducer;